import { render, staticRenderFns } from "./SummaryCards.vue?vue&type=template&id=584afc81&scoped=true&"
import script from "./SummaryCards.vue?vue&type=script&lang=js&"
export * from "./SummaryCards.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCards.vue?vue&type=style&index=0&id=584afc81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584afc81",
  null
  
)

export default component.exports